export default "__VITE_ASSET__Cz_7LcLV__"